import { GlobalOutlined } from "@ant-design/icons";
import { Button, Dropdown } from "antd";
import { useTranslation } from "react-i18next";
import { useLanguage } from "../../contexts/LanguageContext";

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const { changeLanguage, language } = useLanguage();

  const items = [
    {
      key: "en",
      label: (
        <div className="flex items-center gap-2">
          <span>🇬🇧</span>
          <span>English</span>
        </div>
      ),
    },
    {
      key: "ar",
      label: (
        <div className="flex items-center gap-2">
          <span>🇸🇦</span>
          <span>العربية</span>
        </div>
      ),
    },
    {
      key: "tr",
      label: (
        <div className="flex items-center gap-2">
          <span>🇹🇷</span>
          <span>Türkçe</span>
        </div>
      ),
    },
  ];

  const handleMenuClick = ({ key }) => {
    changeLanguage(key);
  };

  return (
    <Dropdown
      menu={{
        items,
        onClick: handleMenuClick,
        selectedKeys: [language],
      }}
      placement="bottomRight"
      trigger={["click"]}>
      <Button
        type="text"
        icon={<GlobalOutlined className="text-lg" />}
        className="flex items-center gap-2 h-10 px-3 bg-white dark:bg-[#1C1B20] border border-gray-100 dark:border-gray-700 rounded-lg shadow-sm hover:bg-gray-50 dark:hover:bg-gray-800 transition-all">
        <span className="hidden md:inline font-medium">
          {language === "ar" ? "العربية" : language === "tr" ? "Türkçe" : "English"}
        </span>
      </Button>
    </Dropdown>
  );
};

export default LanguageSwitcher;

